import module from './core.ui.module'

export default module.name
